export default "__VITE_ASSET__nsLVU8YT__"